var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 13,
    viewBox: "0 0 16 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.91451 12.2575H0.55399C0.2539 12.2575 0 12.0152 0 11.7035V0.554014C0 0.253924 0.242358 0 0.55399 0H9.91451C10.0646 0 10.2031 0.0577111 10.3069 0.161589L15.8355 5.69017C16.0548 5.90947 16.0548 6.25573 15.8355 6.46348L10.3069 12.0844C10.2031 12.1883 10.0646 12.246 9.91451 12.246V12.2575Z",
    fill: "#EEFFF6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector1);
export default __webpack_public_path__ + "static/media/vector-1.8d19009ec5984c0f3eb8d708fc394774.svg";
export { ForwardRef as ReactComponent };